import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=0838b1ec&scoped=true"
import script from "./PC.vue?vue&type=script&lang=ts"
export * from "./PC.vue?vue&type=script&lang=ts"
import style0 from "./PC.vue?vue&type=style&index=0&id=0838b1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838b1ec",
  null
  
)

export default component.exports